import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".AdyenApplePayButton-module_applePayContainer__RxE1N > button, html .AdyenApplePayButton-module_applePayContainer__RxE1N > [type=button] {\n  -webkit-appearance: -apple-pay-button;\n  width: 100%;\n}\n\n.AdyenApplePayButton-module_applePayRoundBorder__osSCz > button, html .AdyenApplePayButton-module_applePayRoundBorder__osSCz > [type=button] {\n  border-radius: var(--pp-radius-full);\n}";
var styles = {"applePayContainer":"AdyenApplePayButton-module_applePayContainer__RxE1N","applePayRoundBorder":"AdyenApplePayButton-module_applePayRoundBorder__osSCz"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=AdyenApplePayButton.module.scss.js.map
